import './setupResizeObserver'
import React from 'react'
import { createRoot } from 'react-dom/client'
import './assets/locales/i18n'
import { store } from './redux/store'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import App from './App'
import { ThemeAccentProvider } from './contexts/ThemeAccentContext'
import { NotificationProvider } from './providers/NotificationProvider'
import ThemeFaviconUpdater from './theme/ThemeFaviconUpdater'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root not found')
}

createRoot(container).render(
  <Provider store={store}>
    <ThemeAccentProvider>
      <NotificationProvider>
        <CssBaseline />
        <ThemeFaviconUpdater />
        <Router>
          <App />
        </Router>
      </NotificationProvider>
    </ThemeAccentProvider>
  </Provider>,
)
